import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Stack, Typography } from '@mui/material';

const rows = [
  ['Margin Mode', 'CROSS'],
  ['Leverage', 'x10'],
  ['Volume danh nghĩa', '500 USDT'],
  ['Margin thực tế', '50 USDT'],
];

export default function OrderConfirmDialog({ open, symbol, side, submitting, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Xác nhận vào lệnh Futures</DialogTitle>
      <DialogContent>
        <Stack spacing={1.25} sx={{ mt: 1 }}>
          <Typography><strong>Symbol:</strong> {symbol}</Typography>
          <Typography><strong>Side:</strong> {side}</Typography>
          {rows.map(([label, value]) => <Typography key={label}><strong>{label}:</strong> {value}</Typography>)}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Hủy</Button>
        <Button variant="contained" color={side === 'LONG' ? 'success' : 'error'} onClick={onConfirm} disabled={submitting}>
          {submitting ? 'Đang gửi...' : 'Xác nhận'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
